import { isProd } from "Services/utils";
import handleFormJoinSubmitServerError from "./eventHandlers/formJoinSubmitServerError";
import handleFormJoinSubmitValidationError from "./eventHandlers/formJoinSubmitValidationError";
import handleFormJoinSucceed from "./eventHandlers/formJoinSucceed";
import handlePageView from "./eventHandlers/pageView";

// Event name const to keep everthing consistent
const EVENT = {
    // Special events
    VIRTUAL_PAGE_VIEW: "virtual_page_view",

    // Main page events
    FORM_JOIN_STARTED: "form_join_started",
    FORM_JOIN_SUBMIT_SERVER_ERROR: "form_join_submit_server_error",
    FORM_JOIN_SUBMIT_VALIDATION_ERROR: "form_join_submit_validation_error",
    FORM_JOIN_SUCCEED: "form_join_succeed",
    BUTTON_FORM_JOIN_SUBMIT: "button_form_join_submit",

    // Confirm page events
    BUTTON_CONGRATS_SHOP_NOW: "button_congrats_shop_now"
};

// Handlers defined in seperate files to avoid mess and encapsulate any event speciffic logic
const EVENT_HANDLERS = {
    [EVENT.VIRTUAL_PAGE_VIEW]: handlePageView,

    [EVENT.FORM_JOIN_STARTED]: () => pushEvent({ event: EVENT.FORM_JOIN_STARTED }),
    [EVENT.FORM_JOIN_SUBMIT_SERVER_ERROR]: handleFormJoinSubmitServerError,
    [EVENT.FORM_JOIN_SUBMIT_VALIDATION_ERROR]: handleFormJoinSubmitValidationError,
    [EVENT.FORM_JOIN_SUCCEED]: handleFormJoinSucceed,
    [EVENT.BUTTON_FORM_JOIN_SUBMIT]: () => pushEvent({ event: EVENT.BUTTON_FORM_JOIN_SUBMIT }),

    [EVENT.BUTTON_CONGRATS_SHOP_NOW]: () => pushEvent({ event: EVENT.BUTTON_CONGRATS_SHOP_NOW })
};

function reset() {
    window.dataLayer.push(function () {
        this.reset();
    });
}

// Wrapping in a function to separate the implementation from external code and make mocking easier
function pushEvent(data) {
    window.dataLayer.push(data);
}

function sendEvent(eventType, data) {
    if (!isProd) {
        console.log(`Captcha Debug: Attempting to handle event "${eventType}" with the following data`, data);
    }

    const handler = EVENT_HANDLERS[eventType];

    if (!handler) {
        if (!isProd) {
            console.error(`Captcha Debug: No handler for event type "${eventType}"`);
        }

        return;
    }

    try {
        handler(data);

        if (!isProd) {
            console.log(`Captcha Debug: Event "${eventType}" handled successfully`);
        }
    } catch (e) {
        if (!isProd) {
            console.error(`Captcha Debug: Error handling event "${eventType}"`, e);
        }

        return;
    }
}

export { sendEvent, pushEvent, EVENT, reset };

// Exporting as default to make clear which function is the main one
export default sendEvent;



// WEBPACK FOOTER //
// ./src/services/googleAnalytics/index.js